import { mapActions } from "vuex";

export const rolesListsMixin = {
  data() {
    return {
      rolesData: [],
      roles: [],
      rolesF: [],
    };
  },

  computed: {
    mainHeadersRoles() {
      return [
        {
          text: this.$i18n.t("Name"),
          align: "left",
          value: "name",
          width: "45%",
        },
        {
          text: this.$i18n.t("Description"),
          align: "left",
          value: "email",
          width: "30%",
        },
        {
          text: this.$i18n.t("Company"),
          align: "left",
          value: "status",
          width: "25%",
        },
      ];
    },
  },

  methods: {
    ...mapActions(["fetchAllClientRolesParams"]),

    async getAllRoles(queryParams = null) {
      this.loading = true;
      try {
        this.roles = await this.fetchAllClientRolesParams(queryParams);
        if (this.roles.data) {
          this.rolesData = this.roles.data.map((role) => ({
            ...role,
            companyName: role.company.name,
          }));
          this.roles.data.map((role) => {
            role.permissions.map((permission) => ({
              ...permission,
              label: this.$i18n.t(permission.label)
            }))
          })
        }
      } catch (error) {
        console.error(error);
      } finally {
        this.rolesF = this.roles.data
        this.loading = false;
        // this.$nextTick(() =>
        //   this.updateLocalPagination(this.paginationFromParent)
        // );
      }
    },
    // getRoleRowsFromLocalStorage(id) {
    //   let rows = parseInt(localStorage.getItem(id));
    //   if (rows) {
    //     return rows;
    //   } else {
    //     return 15;
    //   }
    // },
    // setRoleRowsOnLocalStorage(id, rows) {
    //   localStorage.setItem(id, rows);
    // },
    // setRoleStatus(role) {
    //   if (role) {
    //     role.status = role.status ? "active" : "inactive";
    //   }
    // },

    // isActive(status) {
    //   return status === "active" || status === true;
    // },
  },
};



// WEBPACK FOOTER //
// ./src/mixins/management/rolesListsMixin.js